import React from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
mapboxgl.accessToken = process.env.REACT_MAPBOX_ACCESS_TOKEN;
import "../../css/map.scss";
import { nFormatter } from '../Helper';

import { CloudSearchAPICall } from '../actions/searchcall';
import Cookies from 'js-cookie';
import APICall from '../actions/apicall';
import ClaimBottomSheet from './Mobile/ClaimBottomSheet';
import LoginBottomSheet from './Mobile/LoginBottomSheet';
import AddBusinessBottomSheet from './Mobile/AddBusinessBottomSheet';
import ContactBusinessBottomSheet from './Mobile/ContactBusiness';
import OwnManageBusinessBottomSheet from './Mobile/OwnManageBusiness';
import WorkerManager from '../actions/WorkerManager';
import cancelIcon from '../../images/cancelIcon.png';
import SetPasswordSheet from './Mobile/SetPasswordSheet';
import ReactDOM from 'react-dom';
import SVGImage from './reusable/SelectIcon';

class Map extends React.Component {
    constructor(props) {
        super(props);
    
        let business = null;
        let suggester = null;
        let searchValue = null;
        let businessName = '';
        let zoom = 16.1;
        let marker = 1;
        let businessData = null;
        let showBanner = true;
        this.searchRef = React.createRef();

        let accessToken = Cookies.get('access_token') ?? null;
        if (accessToken) {
            var token_expires_in = Cookies.get('token_expires_in');
            var time = new Date();
            var current_time = time.toISOString();
            if (current_time > token_expires_in) {
                Cookies.remove('access_token');
                Cookies.remove('token_expires_in');
                Cookies.remove('username');
                window.location.reload();
            }
        }

        const searchParams = new URLSearchParams(this.props.location.search);
        var sendBusinessPk = searchParams.get('id');
        var sendBusinessType = searchParams.get('type');
        var tokenCode = searchParams.get('token');
        
        if (props.location.state) {
            businessData = props.location.state.businessData;
        }

        let storedSuggester = window.localStorage.getItem('suggester');
        let storedSearchValue = window.localStorage.getItem('searchValue');
        let storedNameSuggester = window.localStorage.getItem('nameSuggester');
        let storedBusinessName = window.localStorage.getItem('businessName');
        let categoryTypes = ['Restaurants & Food', 'Manufacturing', 'Service Businesses', 'Retail',
                                'Entertainment & Recreation', 'Building & Construction', 'Transportation & Storage', 'Accommodation and Food Services',
                                'Construction', 'Wholesale Trade', 'Retail Trade', 'Transportation and Warehousing', 'Professional, Scientific, and Technical Services', 
                                'Arts, Entertainment, and Recreation', 'Accommodation and Food Services'];
        // Removed 'Airbnb'
        if (business == null) {
            const selectedBusiness = window.localStorage.getItem('selectedBusiness');
            if (selectedBusiness != 'undefined') {
                business = JSON.parse(window.localStorage.getItem('selectedBusiness'));
            }
        }
       
        if (storedNameSuggester == 'null') {
            suggester = storedSuggester;
        }
        else {
            suggester = storedNameSuggester
        }
        if (storedBusinessName == 'null') {
            businessName = ''
        }
        else {
            businessName = storedBusinessName
        }
       
        if (searchValue == null) {
            searchValue = storedSearchValue;
        }

        if (Cookies.get('banner_viewed')) {
            showBanner = false
        }
      
        console.log('marker', marker);
        console.log('zoom', zoom);
        console.log('suggester', suggester);

        this.state = {
            zoom: zoom,
            marker: marker,
            searchedBusiness: business,
            searchValue: searchValue,
            suggester: suggester,
            industryTypes: categoryTypes,
            isBottomSheetOpen: false,
            isAccountBottomSheetOpen: false,
            businessName: businessName,
            openClaimSheet: false,
            openAccountSheet: false,
            businessData: businessData,
            refreshMarkers: false,
            openAddBusinessSheet: false,
            selectedBusinessId: null,
            sendBusinessId: null,
            sendBusinessPk: sendBusinessPk,
            sendBusinessType: sendBusinessType,
            verifiedData: null,
            showTag: false,
            centerMarker: false,
            callBusinessAPI: true,
            addBusinessLogin: false,
            openContactBusiness: false,
            openOwnBusiness: false,
            openDisputeBusiness: false,
            showInbox: false,
            callCategory: false,
            showBanner: showBanner,
            openSetPassword: false,
            callBusinessName: false
        };

        this.currentMarkerType = -1;
        this.tokenCode = tokenCode
        this.mapContainer = React.createRef();
        this.CloudSearchAPICall = new CloudSearchAPICall();
        this.currentMarkers = [];
        this.categoryType = null;
        this.worker = WorkerManager.newWorker();
        this.showLoginContent = false;
        this.showBusinessSheet = this.showBusinessSheet.bind(this);
        this.loadMarkers = this.loadMarkers.bind(this);
        this.RedirectAddBusiness = this.RedirectAddBusiness.bind(this);
        this.handleClaimBottomSheetOpen = this.handleClaimBottomSheetOpen.bind(this);
        this.handleAccountBottomSheetOpen = this.handleAccountBottomSheetOpen.bind(this);
        this.handleClaimBottomSheetClose = this.handleClaimBottomSheetClose.bind(this);
        this.handleAccountBottomSheetClose = this.handleAccountBottomSheetClose.bind(this);
        this.handleAddBusinessBottomSheetOpen = this.handleAddBusinessBottomSheetOpen.bind(this);
        this.handleAddBusinessBottomSheetClose = this.handleAddBusinessBottomSheetClose.bind(this);
        this.handleBusinessDetails = this.handleBusinessDetails.bind(this);
        this.handleCloseContactBusiness = this.handleCloseContactBusiness.bind(this);
        this.handleCloseOwnBusiness = this.handleCloseOwnBusiness.bind(this);
        this.handleCloseDisputeBusiness = this.handleCloseDisputeBusiness.bind(this);
        this.handleCloseBanner = this.handleCloseBanner.bind(this);
        this.handleCloseSetPassword = this.handleCloseSetPassword.bind(this);
    }

    RedirectAddBusiness = () => {
        if (this.state.openContactBusiness) return
        let userId = Cookies.get('rs11_user_id') ?? 0;
        let accessToken = Cookies.get('access_token') ?? null;

        window.dataLayer.push({
            'event': 'add_business_start',
            'addBusinessTriggeredFrom': 'map'
        });

        if (accessToken == null) {
            this.setState({
                isAccountBottomSheetOpen: true,
                openAccountSheet: true,
                addBusinessLogin: true,
                showInbox: false
            });
        }
        else {
            this.setState( {openAddBusinessSheet: true});
        }
    }

    handleClaimBottomSheetOpen = () => {
        this.setState({ isBottomSheetOpen: true });
    };
    
    handleClaimBottomSheetClose = (showAction, mail) => {
        (location.pathname != '/map') && this.props.history.push('/map');
        let accessToken = Cookies.get('access_token');
        if (this.tokenCode != null && accessToken != null) {      
            this.tokenCode = null;
        }

        if (showAction == 'create') {
            this.showLoginContent = false;
            this.setState({ 
                isBottomSheetOpen: false,
                isAccountBottomSheetOpen: true,
                openAccountSheet: true
            }); 
        }
        else if (showAction == 'signin') {
            this.showLoginContent = true;
            this.setState({ 
                showInbox: false,
                isBottomSheetOpen: false,
                isAccountBottomSheetOpen: true,
                openAccountSheet: true
            });
        }
        else if (showAction == 'add') {
            this.setState({ isBottomSheetOpen: false }); 
            this.RedirectAddBusiness();
        }
        else if (showAction == 'own') {
            this.setState({ openOwnBusiness: true});
        }
        else if (showAction == 'contact') {
            this.setState({ openContactBusiness: true});
        }
        else if (showAction == 'inbox') {
            this.setState({ showInbox: true});
            this.showLoginContent = false;
            this.setState({ 
                isBottomSheetOpen: false,
                isAccountBottomSheetOpen: true,
                openAccountSheet: true
            }); 
        }
        else if (showAction == 'close') {
            this.setState({ isBottomSheetOpen: false }); 
        }
    };

    handleAccountBottomSheetOpen = () => {
        this.setState( {isAccountBottomSheetOpen: true});
    }

    handleAccountBottomSheetClose = (reload, currentSheet) => {
        if (reload) {
            this.setState({ refreshMarkers: true});
            this.loadMarkers(this, 'load');
            this.setState({ isAccountBottomSheetOpen: false});
            if (this.state.addBusinessLogin) {
                this.RedirectAddBusiness();
            }
            else {
                let accessToken = Cookies.get('access_token');
                let params = {'business_id': this.state.selectedBusinessId, 'type': this.categoryType}
                APICall.GetBusinessValuation(params, accessToken, (response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        this.setState({ 
                            claimPopupBusiness: response.data.data,
                            isBottomSheetOpen: true,
                            openClaimSheet: true
                        });
                    }
                    else {
                        this.setState({ isAccountBottomSheetOpen: false}); 
                    }
                });
            }
            this.props.history.push('/map');
        }
        else {
            this.setState({ isAccountBottomSheetOpen: false}); 
        }
    }

    handleAddBusinessBottomSheetOpen = () => {
        this.setState( {openAddBusinessSheet: true})
    }

    handleAddBusinessBottomSheetClose = () => {
        this.setState( {openAddBusinessSheet: false});
        this.props.history.push('/map');
    }

    handleCloseOwnBusiness = () => {
        this.setState({ openOwnBusiness: false });
    }

    handleCloseContactBusiness = () => {
        this.setState({ openContactBusiness: false});
    }

    handleCloseDisputeBusiness = () => {
        this.setState({ openDisputeBusiness: false });
    }

    handleClickBanner = () => {
        let userId = Cookies.get('rs11_user_id') ?? 0;
        window.dataLayer.push({'event': 'banner_click'});
        this.props.history.push('/help');
    }

    handleCloseBanner = () => {
        let userId = Cookies.get('rs11_user_id') ?? 0;
        window.dataLayer.push({'event': 'banner_close'});
        this.setState({ showBanner: false });
        Cookies.set('banner_viewed', true);
    }

    handleCloseSetPassword = () => {
        this.setState({ openSetPassword: false});
        this.props.history.push('/map');
    }

    handleBusinessDetails(feature, action) {
        let accessToken = Cookies.get('access_token');
        if (feature.id == null) return

        if (accessToken == null) {
            let params = {'business_id': feature.id, 'type': feature.fields.category}
            APICall.GetBusinessData(params, (response) => {
                if (response.status == 200 && response.data.status == 'success') {
                    this.setState({ claimPopupBusiness: response.data.data});
                    return
                }
            });  
        }

        APICall.GetBusinessValuation({'business_id': feature.id, 'type': feature.fields.category}, accessToken, (response) => {
            if (response == undefined) {
                return
            }
            if (response.status == 200 && response.data.status == 'success') {
                this.setState({ claimPopupBusiness: response.data.data });
            }
        });
    }

    renderSVGImageToString(categoryName) {
        const svgContainer = document.createElement('div');
        ReactDOM.render(<SVGImage category={categoryName} />, svgContainer);
        return svgContainer.innerHTML;
    }

    showBusinessSheet(feature) {
        this.setState({ claimPopupBusiness: null})
        let userId = Cookies.get('rs11_user_id') ?? 0;
        if (feature && feature.hasOwnProperty('fields') && feature.fields.hasOwnProperty('location_address_city')) {
            window.dataLayer.push({
                'event': 'marker_click', 
                'latitude': feature.fields.latitude,
                'longitude': feature.fields.longitude, 
                'businessId': feature.id, 
                'businessCity': feature.fields.location_address_city
            });
        }
        this.categoryType = feature.fields.category;
        this.setState({ addBusinessLogin: false });
        this.setState({ 
            selectedBusinessId: feature.id, 
            verifiedData: null,
            showTag: false,
        })
        window.localStorage.setItem('selectedBusiness', JSON.stringify(feature));
        window.localStorage.setItem('suggester', 'zipcode');
        window.localStorage.setItem('searchValue', feature.fields.zip_code);
        window.localStorage.setItem('nameSuggester', 'name');
        window.localStorage.setItem('businessName', feature.fields.business_name);
        window.localStorage.setItem('businessNameAddress', feature.fields.location_address);

        this.setState({ claimPopupBusiness: feature})
        this.setState({isBottomSheetOpen: true})
        this.setState({openClaimSheet: true})
    }

    addMarkerPopup(popupEl, el, long, lat) {
        let popup = new mapboxgl.Popup({ offset: [0, 10]}).setHTML(popupEl);
        const marker = new mapboxgl.Marker({element: el, offset: [0, 20]})
                    .setLngLat([long, lat])
                    .setPopup(popup)
                    .addTo(this.map);
        return marker;
    }

    removeMarkers(num) {
        const { currentMarkers } = this;

        if (currentMarkers[num]) {
            currentMarkers[num].remove();
        } 
    }

    getMarkersAndPopup ( markerType, type, mapData, mapLoadType) {
        const {currentMarkers} = this;
        let i = 0;
        console.log(`marker: ${markerType}`);
        if (![1, 2, 3].includes(markerType)) {
            return;
        }

        for (const feature of mapData) {
            const lat = feature.fields.latitude;
            const long = feature.fields.longitude;
            if (!lat || !long) {
                console.warn("Feature missing co-ordinates", feature);
                continue;
            }

            // if (parseInt(feature.fields.valuation) <= 0) {
            //     continue;
            // }

            // create a HTML element for each feature
            let el = document.createElement('div');
            // Marker Element
            el.className = `marker marker-${i}`;

            let valuationClass = 'valuation-text';
            let dollarClass = '';

            if (parseFloat(feature.fields.valuation) != 0) {
                var valuationText = nFormatter(feature.fields.valuation).slice(0, -1);
                var valuationSymbol = nFormatter(feature.fields.valuation).slice(-1);
            }
            else {
                var valuationText = 'COMING SOON';
                var valuationSymbol = '';
                dollarClass = `dollar-class-${i}`;
                if (markerType == 2) {
                    valuationClass = 'valuation-coming-2';
                }
            }

            const svgImageString = this.renderSVGImageToString(feature.fields.category);


            let popupEl = '';
            if (markerType === 1) {
                el.innerHTML = `<div class="marker-popup-blur" id="marker-popup-${i}">
                    <p><sup>&#36;</sup><div class="value-container"><span>${valuationText}</span><p class="rate-symbol">${valuationSymbol}</p></div></p>
                    </div>`
            }

            if (markerType === 2) {
                el.className = `marker marker-2-${i}`;
                el.innerHTML = `<div class="marker-2-popup-blur marker-2-popup-highlight-1" id="marker-popup-highlight-1">
                        <div class="logo-image-2">
                            ${svgImageString}
                        </div>
                        <p><sup id=dollar-${i} class=${dollarClass}>&#36;</sup><div class="value-container"><span id="valuation-${feature.id}" class=${valuationClass}>${valuationText}</span><p id="valuation-symbol-${feature.id}" class="rate-symbol">${valuationSymbol}</p></div></p>
                        <span class="arrow-down"></span>
                    </div>`;
            }

            if (markerType === 3) {
                let business_name = feature.fields.business_name || '';
                if (business_name.length > 25) {
                    business_name = business_name.substring(0, 25) + "...";
                }
                    el.className = `marker marker-2-${i}`;
                        el.innerHTML = `<div class="marker-2-popup-blur name-business" id="marker-popup-${i}">
                                <div class="logo-image">
                                    ${svgImageString}
                                    <span class="arrow-down"></span>
                                </div>
                                <p class="business-name" title="${feature.fields.business_name}">${business_name}</p>
                                <div class="value-container name-text"><span id="valuation-${feature.id}" class=${valuationClass}>$${valuationText}</span><p id="valuation-symbol-${feature.id}" class="rate-symbol" >${valuationSymbol}</p></div>
                            </div>`;
            }

            // make a marker for each feature and add it to the map
            const marker = this.addMarkerPopup(popupEl, el, long, lat);
            marker.feature_id = feature.id;
            let markerEle = marker.getElement();

            currentMarkers.push(marker);

            markerEle.addEventListener('click', () => {
                if (markerType != 1) {
                    this.showBusinessSheet(feature);
                }
            }, { passive: true });
            i += 1;
        }

        if (this.state.suggester == 'name') {
            const business = this.state.searchedBusiness;
            let el = document.createElement('div');
            let long = business.fields.longitude;
            let lat = business.fields.latitude;
            
            
            let accessToken = Cookies.get('access_token') ?? null;
            
            let popupEl = '';

            el.className = `marker`;

            let dollarClass = '';
            let valuationClass = 'valuation-text';
        
            console.log('business.fields.valuation', business);
            if (parseFloat(business.fields.valuation) != 0 && business.fields.valuation != undefined) {
                var valuationText = nFormatter(business.fields.valuation).slice(0, -1);
                var valuationSymbol = nFormatter(business.fields.valuation).slice(-1);
            }
            else {
                var valuationText = 'COMING SOON';
                var valuationSymbol = '';
                dollarClass = `dollar-class-${i}`;
                if (markerType == 2) {
                    valuationClass = 'valuation-coming-2';
                }
            }

            const svgImageString = this.renderSVGImageToString(business.fields.category);

            if (markerType == 1) {
                    el.innerHTML = `<div class="marker-popup-blur" id="marker-popup-highlight-1">
                        <p><sup>&#36;</sup><div class="value-container"><span>${valuationText}</span><p class="rate-symbol">${valuationSymbol}</p></div></p>
                        </div>`; 
            }

            if (markerType == 2) {
            // Marker Element
                el.className = `marker marker-2-highlight`;
    
                    el.innerHTML = `<div class="marker-2-popup-blur marker-2-popup-highlight-1" id="marker-popup-highlight-1">
                            <div class="logo-image-2">
                                ${svgImageString}
                            </div>
                            <p><sup id=dollar-${business.id + i} class=${dollarClass}>&#36;</sup><div class="value-container"><span id="valuation-${business.id + i}" class=${valuationClass}>${valuationText}</span><p id="valuation-symbol-${business.id + i}" class="rate-symbol">${valuationSymbol}</p></div></p>
                            <span class="arrow-down"></span>
                        </div>`;
                // }
            }

            if (markerType == 3) {
                el.className = `marker marker-2-highlight`;
                if (business.fields.business_name.length > 25) {
                    var nameBusiness = business.fields.business_name.substring(0, 25) + "...";
                }
                else {
                    var nameBusiness = business.fields.business_name;
                }
                if (accessToken == null) {
                    el.innerHTML = `<div class="marker-2-popup-blur marker-2-popup-highlight-1 name-business" id="marker-popup-highlight-1">
                            <div class="logo-image">
                                ${svgImageString}
                                <span class="arrow-down"></span>
                            </div>
                            <p class="business-name" title="${business.fields.business_name}">${nameBusiness}</p>
                            <div class="value-container name-text"><span id="valuation-${business.id + i + 1}" class=${valuationClass}>$${valuationText}</span><p id="valuation-symbol-${business.id + i}" class="rate-symbol">${valuationSymbol}</p></div>
                        </div>`;
                }
            }

            const marker = this.addMarkerPopup(popupEl, el, long, lat);
            marker.feature_id = business.id;
            let markerEle = marker.getElement();
           
            markerEle.addEventListener('click', () => {
                if (markerType != 1) {
                    this.showBusinessSheet(business);
                }
            }, { passive: true });
            currentMarkers.push(marker);
        }

    }

    loadCountryData() {
        let url = 'https://d2ynm4vxx4p4wt.cloudfront.net/data/poc-business.csv';
        WorkerManager.postMessage(this.worker, 'URL_TO_GEOJSON', {url}, (status, geoJson) => {
            this.loadCountryDataLayer(geoJson)
        });
        // this.map.addSource('rs11-smb-locations', {
        //     type: 'vector',
        //     url: 'mapbox://rs11-support.rs11-smb-locations-v1'
        // });

        // this.map.addLayer({
        //     'id': 'country_markers-0',
        //     'type': 'circle',
        //     'source': 'rs11-smb-locations',
        //     'source-layer': 'rs11-smb-locations-l1',
        //     'minzoom': 3,
        //     'maxzoom': 11,
        //     'paint': {
        //         'circle-radius': [
        //             'step',
        //             ['zoom'],
        //             2,
        //             6, 2,
        //             7, 3.5,
        //             11, 5
        //         ],
        //         'circle-color': '#807F7F'
        //     }
        // });
    }

    loadCountryDataLayer(geoJson) {
        this.map.addSource('country_markers', geoJson);
        this.map.addLayer({
            'id': 'country_markers-0',
            'type': 'circle',
            'source': 'country_markers',
            'minzoom': 3,
            'maxzoom': 11,
            'paint': {
                'circle-radius': [
                    'step',
                    ['zoom'],
                        2,
                        3, 2,
                        6, 3.5,
                        7, 5
                    ],
                // 'circle-blur': 0.5,
                'circle-color': '#807F7F'
            }
        });
    }
        

    adjustMapWidth(zoom) {
        let event;
        if (typeof (Event) === 'function') {
            event = new Event('resize');
        } else { /*IE*/
            event = document.createEvent('Event');
            event.initEvent('resize', true, true);
        }
        window.dispatchEvent(event);

    }

    loadMarkers = (self, mapLoadType) => {
        const { industryTypes,suggester,searchValue } = self.state;
        const center = self.map.getCenter();
        const zoom = self.map.getZoom();
        const fields = {
            'latlong': `${ center[ 'lat' ] },${ center[ 'lng' ] }`,
        };

        let markerType = 0;
        if ( zoom >= 11 && zoom < 13 ) { markerType = 1 } 
        else if ( zoom >= 13 && zoom < 16) { markerType = 2; }
        else if (zoom >= 16) { markerType = 3 }

        self.setState( { "marker": markerType } );
        let mapDetails = [];
        if (suggester == 'name' && mapLoadType != 'dragend' && this.state.callBusinessName) {
            let business = this.state.searchedBusiness
            console.log('Check 1');

            if (this.state.centerMarker) {
                console.log('Check 2');
                self.map.setCenter( [ business['fields']['longitude'], business['fields']['latitude'] ] );
                this.setState({ centerMarker: false });
            }

            const geofields = {
                'latlong': `${ business.fields.latitude },${ business.fields.longitude }`,
            };

            this.loadBoundingBox(geofields, mapDetails, markerType)
            this.setState({ callBusinessName: false })
        }
        else if (mapLoadType != 'dragend' && this.state.callCategory && (suggester == 'city' || suggester == 'zipcode')) {
            this.CloudSearchAPICall.getSearchCategory(searchValue, suggester, industryTypes, (res) =>
            {
                console.log('SEARCH__TYPE Category search called category');
                mapDetails = [];
                window.localStorage.setItem('selectedBusiness', JSON.stringify(res['hits']['hit'][0]));
                
                let details = mapDetails.concat( res[ 'hits' ][ 'hit' ] );

                if (details.length >= 1) {
                    let business = details[0];
                    const center = this.map.getCenter();
                    if (this.state.centerMarker) {
                        self.map.setCenter( [ res['hits']['hit'][0]['fields']['longitude'], res['hits']['hit'][0]['fields']['latitude'] ] );
                        this.setState({ centerMarker: false });
                    }

                    const geofields = {
                        'latlong': `${ business['fields']['latitude'] },${ business['fields']['longitude'] }`,
                    };
                    this.loadBoundingBox(geofields, details, markerType);

                } else {
                    self.removeMarkers();
                }
                    
            });
            this.setState({ callCategory: false});
        }
        else if (mapLoadType == 'dragend') {
            console.log('DRAGEND');
            this.loadBoundingBox(fields, mapDetails, markerType);

        } else {
            this.loadBoundingBox(fields, mapDetails, markerType);
        }
    }

    loadBoundingBox (geofields, details, markerType) {
        let se = this.map.getBounds().getSouthEast();
        let nw = this.map.getBounds().getNorthWest();
        let upperLeft = `${ nw[ 'lat' ] },${ nw[ 'lng' ] }`;
        let lowerRight = `${ se[ 'lat' ] },${ se[ 'lng' ] }`;

        this.CloudSearchAPICall.getBoundingBox(geofields, upperLeft, lowerRight, this.state.industryTypes, (res) => {
            let data = details.concat(res['hits']['hit']);
            this.reloadMarkersFromData(data, markerType);

        });
    }

    reloadMarkersFromData(data, markerType) {
        let {currentMarkers} = this;
        let {refreshMarkers} = this.state;

        if (this.currentMarkerType !== markerType || refreshMarkers) {
            // do a full refresh
            var allMarkerArray = currentMarkers;
            for (let j = currentMarkers.length - 1; j>=0; j--) {
                this.removeMarkers(j);
                allMarkerArray = allMarkerArray.filter((item, index) => {
                    return index != j;
                });
            }
            this.currentMarkers = allMarkerArray;
            this.getMarkersAndPopup(markerType, 'common', data);
            this.currentMarkerType = markerType;
            (refreshMarkers) && this.setState({refreshMarkers: false});
            return;
        }
        let loadedFeatureIds = currentMarkers.map(m => m.feature_id);
        let featuresToAdd = [];

        let newFeatureIds = [];
        for (let feature of data) {
            newFeatureIds.push(feature.id);
            if (!loadedFeatureIds.includes(feature.id)) {
                featuresToAdd.push(feature);
            }
        }
        let featureIdsToRemove = loadedFeatureIds.filter(f => !newFeatureIds.includes(f));

        var markerArray = currentMarkers;
        for (let j = currentMarkers.length - 1; j>=0; j--) {
            if(featureIdsToRemove.includes(currentMarkers[j].feature_id)) {
                this.removeMarkers(j);
                markerArray = markerArray.filter((item, index) => {
                    return index != j;
                });
            }
        }
        this.currentMarkers = markerArray;
        this.getMarkersAndPopup(markerType, 'common', featuresToAdd);
    }
                       
    componentDidMount ( props )
    {
        let { searchedBusiness, zoom } = this.state;
        let longlat = [ -122.4087195,37.7772775 ]; // City Center Inn & Suites, San Francisco, CA

        if (window.localStorage.getItem('userLatlong')) {
            if (JSON.parse(window.localStorage.getItem('userLatlong') != 'null')) {
                longlat = JSON.parse(window.localStorage.getItem('userLatlong'));
            }
        }

        console.log( "Component Mounted.");
        
        if ( searchedBusiness != null )
        {
            const { fields } = searchedBusiness;
            const { longitude,latitude } = fields;
            longlat = [ longitude,latitude ];
        }

        this.adjustMapWidth( zoom );
        this.map = new mapboxgl.Map( {
            container: this.mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            center: longlat,
            zoom: zoom
        } );

        this.setState( {
            mapState: this.map
        } );
      
        this.map.setMinZoom( 3 );
        this.map.setMaxZoom( 20 );

        this.map.on( 'load',() =>
        {
            this.setState( {
                'currentZoom': this.map.getZoom()
            } );

            this.loadCountryData();

            const zoom = this.map.getZoom();
            this.map.setZoom(zoom+0.0001);

            const iterable = [ 0,1,2 ];

            for ( const value of iterable )
            {
                // Change the cursor to a pointer when the mouse is over the places layer.
                this.map.on( 'mouseenter',`country_markers-${ value }`,( e ) =>
                {
                    this.map.getCanvas().style.cursor = 'pointer';
                    // Copy coordinates array.
                    const coordinates = e.features[ 0 ].geometry.coordinates.slice();
                    const description = e.features[ 0 ].properties;

                    // Ensure that if the map is zoomed out such that multiple
                    // copies of the feature are visible, the popup appears
                    // over the copy being pointed to.
                    while ( Math.abs( e.lngLat.lng - coordinates[ 0 ] ) > 180 )
                    {
                        coordinates[ 0 ] += e.lngLat.lng > coordinates[ 0 ] ? 360 : -360;
                    }
                    
                    const popupEl = `<div class="marker-tooltip marker-tooltip-layer">
                        <p class="">${description.business_name}</p>
                        </div>`;
                    this.popup = new mapboxgl.Popup()
                    .setLngLat(coordinates)
                    .setHTML(popupEl)
                    .addTo(this.map);
                    // }
                }, { passive: true });

                // Change it back to a pointer when it leaves.
                this.map.on('mouseleave', `country_markers-${value}`, () => {
                    this.popup.remove();
                    this.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', `country_markers-${value}`, (e) => {
                }, { passive: true });
            }
            console.log('SEARCH BY CATEGORY: from initial load');
        });

        this.map.on('dragend', () => {
            console.log('SEARCH BY CATEGORY: from dragend event');
            this.loadMarkers(this, 'dragend');
        });  

        this.map.on('zoomend', () => {
            const zoom = this.map.getZoom();
        
            this.adjustMapWidth(zoom);
            console.log('zoom', zoom);
            const {searchedBusiness, setZoom, suggester} = this.state;

            let longitude = -84.00654;
            let latitude = 30.44629;
            if (searchedBusiness != null) {
                const { fields } = searchedBusiness;
                longitude = fields.longitude;
                latitude = fields.latitude;
            }

            this.setState({'currentZoom': zoom});
            if (setZoom) {
                this.map.setCenter([longitude, latitude]);
                this.setState({setZoom: false});
            }

            console.log('SEARCH BY CATEGORY: from zoom event');
            if (this.state.sendBusinessPk != null && this.state.sendBusinessType != null) {
                return
            }
            this.loadMarkers(this, 'zoomend');
        });
        
        if (this.state.businessData != null) {

            if (this.state.businessData == null) {
                this.setState({
                    isBottomSheetOpen: true,
                    openClaimSheet: true,
                })
            }
            else {
                let accessToken = Cookies.get('access_token');
                this.categoryType = this.state.businessData.fields.category;
                let params = {'business_id': this.state.businessData.id, 'type': this.state.businessData.fields.category}
                if (accessToken) {
                    APICall.GetBusinessValuation(params, accessToken, (response) => {
                        if (response.status == 200 && response.data.status == 'success') {
                            this.setState({ claimPopupBusiness: response.data.data});
                            this.setState({ isBottomSheetOpen: true });
                            this.setState({selectedBusinessId: response.data.data.id})
                            this.setState({openClaimSheet: true})
                        }
                    });
                }
                else {
                    APICall.GetBusinessData(params, (response) => {
                        if (response.status == 200 && response.data.status == 'success') {
                            this.setState({ claimPopupBusiness: response.data.data});
                            this.setState({ isBottomSheetOpen: true });
                            this.setState({openClaimSheet: true});
                            this.setState({selectedBusinessId: response.data.data.id})
                        }
                    });
                }
            }

        }


        if (this.state.sendBusinessPk != null && this.state.sendBusinessType != null) {
            this.setState({
                sendBusinessPk: this.state.sendBusinessPk,
                sendBusinessType: this.state.sendBusinessType,
                isAccountBottomSheetOpen: false,
                centerMarker: true
            })
            let accessToken = Cookies.get('access_token');
            let params = {
                'id': this.state.sendBusinessPk,
                'type': (this.state.sendBusinessType == 1 ? 'airbnb' : 'smb')
            }
            if (accessToken) {
                APICall.GetBusinessValuation(params, accessToken, (response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        window.localStorage.setItem('selectedBusiness', JSON.stringify(response.data.data));
                        this.setState({
                            searchValue: response.data.data.fields.zip_code,
                            businessName: response.data.data.fields.business_name,
                            suggester: 'name',
                            centerMarker: true,
                            searchedBusiness: response.data.data,
                            callBusinessName: true
                        })
                        window.localStorage.setItem('nameSuggester', 'name');
                        window.localStorage.setItem('suggester', 'zipcode');
                        window.localStorage.setItem('searchValue', response.data.data.fields.zip_code);
                        window.localStorage.setItem('businessName', response.data.data.fields.business_name);
                        window.localStorage.setItem('businessNameAddress', response.data.data.fields.location_address);
                        this.loadMarkers(this, 'load');
                        this.setState({ 
                            claimPopupBusiness: response.data.data,
                            isBottomSheetOpen: true,
                            openClaimSheet: true,
                        });
                    }
                    else {
                        this.setState({ isAccountBottomSheetOpen: false}); 
                    }
                });
            }
            else {
                APICall.GetBusinessData(params, (response) => {
                    if (response.status == 200 && response.data.status == 'success') {
                        window.localStorage.setItem('selectedBusiness', JSON.stringify(response.data.data));
                        this.setState({
                            searchValue: response.data.data.fields.zip_code,
                            businessName: response.data.data.fields.business_name,
                            suggester: 'name',
                            centerMarker: true,
                            searchedBusiness: response.data.data,
                            callBusinessName: true
                        })
                        window.localStorage.setItem('nameSuggester', 'name');
                        window.localStorage.setItem('suggester', 'zipcode');
                        window.localStorage.setItem('searchValue', response.data.data.fields.zip_code);
                        window.localStorage.setItem('businessName', response.data.data.fields.business_name);
                        window.localStorage.setItem('businessNameAddress', response.data.data.fields.location_address);
                        this.loadMarkers(this, 'load');
                        this.setState({
                            claimPopupBusiness: response.data.data,
                            isBottomSheetOpen: true,
                            openClaimSheet: true,
                        })
                    }
                    else {
                        this.setState({ isAccountBottomSheetOpen: false}); 
                    }
                });
            }
        }

        if (this.tokenCode != null) {
            let token = this.tokenCode;
            APICall.VerifyEmail(token, (response) => {
                if (response == undefined) return;
                
                if (response.status == 200 && response.data.status == 'success'){
                    if (response.data.data.user.access_token) {
                        var accessToken = response.data.data.user.access_token
                        Cookies.set('access_token', accessToken);    
                    }
                    Cookies.set('rs11_user_id', response.data.data.user.id);

                    this.categoryType =  response.data.data.business.type
                    let suggesterData = response.data.data.business.suggester;

                    (response.data.data.business.suggester == 'zip_code') && (suggesterData = 'zipcode');
                    (response.data.data.business.suggester == 'location_address_city') && (suggesterData = 'city');
                    if (response.data.data.business.name == null) {
                        this.setState({ callCategory: true});
                        this.setState({
                            searchValue: response.data.data.business.suggested_value,
                            suggester: suggesterData,
                            businessName: null,
                            centerMarker: true,
                        })
                        window.localStorage.setItem('suggester', suggesterData);
                        window.localStorage.setItem('searchValue', response.data.data.business.suggested_value);
                        window.localStorage.setItem('nameSuggester', null);
                        window.localStorage.setItem('businessName', null);
                        window.localStorage.setItem('businessNameAddress', null);
                    }
                    else {
                        window.localStorage.setItem('selectedBusiness', JSON.stringify(response.data.data.business));
                        this.setState({
                            searchValue: response.data.data.business.suggested_value,
                            businessName: response.data.data.business.name,
                            suggester: 'name',
                            centerMarker: true,
                            selectedBusinessId: response.data.data.business.id
                        })
                        window.localStorage.setItem('nameSuggester', 'name');
                        window.localStorage.setItem('suggester', response.data.data.business.suggester);
                        window.localStorage.setItem('searchValue', response.data.data.business.suggested_value);
                        window.localStorage.setItem('businessName', response.data.data.business.name);
                        window.localStorage.setItem('businessNameAddress', response.data.data.business.address);
                        this.setState({ callBusinessName: true });
                    }

                    let id = response.data.data.business.id;
                    let linkResponse = response.data.data;
                    if(response.data.data.user.first_time_verify){
                        window.dataLayer.push({'event': 'email_confirmed'});
                    }
                    if (response.data.data.user.set_password) {
                        this.setState({ openSetPassword: true })
                        this.setState({ verifiedData: linkResponse })
                        return
                    }
                    if (id != null) {
                        APICall.GetBusinessValuation({'business_id':id, 'type': response.data.data.business.type}, accessToken, (response) => {
                            if (response.status == 200 && response.data.status == 'success'){
                                window.localStorage.setItem('selectedBusiness', JSON.stringify(response.data.data));
                                this.setState({ searchedBusiness: response.data.data })
                                this.setState({ callBusinessName: true })
                                this.loadMarkers(this, 'load');
                                this.setState({ 
                                    claimPopupBusiness: response.data.data,
                                    isBottomSheetOpen: true,
                                    openClaimSheet: true,
                                    verifiedData: linkResponse,
                                });
                                this.loadMarkers(this, 'load');
                                this.props.history.push('/map')
                            }
                        });
                    }
                    // else if(id == null) {
                    //     if (response.data.data.suggested_value == null) {
                    //         this.props.history.push('/map')
                    //     }
                    //     this.setState({ 
                    //         verifiedData: response.data.data,
                    //         isBottomSheetOpen: true,
                    //         openClaimSheet: (response.data.data.business_name != null ? true : false),
                    //         searchValue: response.data.data.suggested_value,
                    //         claimPopupBusiness: null
                    //     });
                    // }
                    else {
                        this.loadMarkers(this, 'load');
                        this.props.history.push('/map')
                    }
                }
            });
        }
        
        window.history.replaceState(null, '') // Clear state value on refresh.
    }
    componentWillUnmount() {
        if (this.map) {
          this.map.remove();
        }
      }

    render() {

        return (
            <div className={"mapbox-container"}>
                {
                    (this.state.openClaimSheet) && 
                        <ClaimBottomSheet 
                            business={this.state.claimPopupBusiness}
                            isBottomSheetOpen={this.state.isBottomSheetOpen}
                            onBottomSheetOpen={this.handleClaimBottomSheetOpen}
                            onBottomSheetClose={this.handleClaimBottomSheetClose} 
                            verifiedData={this.state.verifiedData}
                            showTag={this.state.showTag}
                        />
                }
                {
                    (this.state.openAccountSheet) && 
                        <LoginBottomSheet
                            isBottomSheetOpen={this.state.isAccountBottomSheetOpen}
                            onBottomSheetOpen={this.handleAccountBottomSheetOpen}
                            onBottomSheetClose={this.handleAccountBottomSheetClose} 
                            selectedBusinessId={this.state.selectedBusinessId}
                            verifiedData={this.state.verifiedData}
                            business={this.state.claimPopupBusiness}
                            showInbox={this.state.showInbox}
                            showLoginContent={this.showLoginContent}
                        />
                }
                {
                    (this.state.openAddBusinessSheet) && 
                        <AddBusinessBottomSheet 
                            isBottomSheetOpen={this.state.openAddBusinessSheet}
                            onBottomSheetOpen={this.handleAddBusinessBottomSheetOpen}
                            onBottomSheetClose={this.handleAddBusinessBottomSheetClose} 
                        />
                }
                {
                    (this.state.openContactBusiness) && 
                        <ContactBusinessBottomSheet 
                            closeContactBusiness={this.handleCloseContactBusiness}
                            business={this.state.claimPopupBusiness}
                        />
                }
                {
                    (this.state.openOwnBusiness) && 
                        <OwnManageBusinessBottomSheet
                            closeOwnBusiness={this.handleCloseOwnBusiness}
                            business={this.state.claimPopupBusiness}

                        />
                }
                {
                    (this.state.openSetPassword) && 
                        <SetPasswordSheet
                            closeSetPassword={this.handleCloseSetPassword}
                            verifiedData={this.state.verifiedData}
                        />
                }
                
                <div className="maps" style={{maxHeight: `calc(100dvh - 5.527638190954774vh)`}}>    
                    <div ref={this.mapContainer} className="map-container" id={"map-container"} />
                    {
                        (this.state.showBanner) && (
                            <div className='map-banner'>
                                <p><span>NOTE:  </span>Beta Version.  SMB valuations may initially be inaccurate and/or exclude real estate values. <span className='learn-more' onClick={() => this.handleClickBanner()}>Learn More</span>
                                </p>
                                <img src={cancelIcon} onClick={() => this.handleCloseBanner()} />
                            </div>
                        )
                    }
                    <div className="add-business-counter">
                        <p className='find-text'>Didn't find a business?</p>
                        <p className='add-text' onClick={() => this.RedirectAddBusiness()}>Add one</p>
                    </div>     
                </div>
            </div>
        );
    }
}

export default Map;

